// eslint-disable-next-line import/prefer-default-export
export class Book {
  constructor(book) {
    Object.assign(this, book);
  }

  getLink() {
    return {
      pathname: this.absolute_url,
      state: { book: this },
    };
  }

  getReaderUrl() {
    return `${this.absolute_url}reader/`;
  }

  getFragmentUrl() {
    return `${this.absolute_url}read/`;
  }

  getReviewsUrl() {
    return `${this.absolute_url}reviews/`;
  }

  getCitationsUrl() {
    return `${this.absolute_url}citations/`;
  }

  getAuthorsUrl() {
    return `${this.absolute_url}authors/`;
  }

  getAuthorsLink() {
    return {
      pathname: this.getAuthorsUrl(),
      state: { book: this },
    };
  }

  getFragmentLink() {
    return {
      pathname: this.getFragmentUrl(),
      state: { book: this },
    };
  }

  getReviewsLink() {
    return {
      pathname: this.getReviewsUrl(),
      state: { book: this },
    };
  }

  getCitationsLink() {
    return {
      pathname: this.getCitationsUrl(),
      state: { book: this },
    };
  }
}

export class Review {
  constructor(review) {
    Object.assign(this, review);
  }

  getLink() {
    return {
      pathname: this.absolute_url,
      state: { review: this },
    };
  }

  getUrl() {
    return this.absolute_url;
  }
}

export class Citation {
  constructor(citation) {
    Object.assign(this, citation);
  }

  getLink() {
    return {
      pathname: this.absolute_url,
      state: { citation: this },
    };
  }

  getUrl() {
    return this.absolute_url;
  }
}
